import React, { createContext, useContext, useState } from "react";

interface PromotionSelectionState {
  selectedPromotionId: string | null;
  setSelectedPromotion: (id: string | null) => void;
}

const PromotionSelectionContext = createContext<PromotionSelectionState | undefined>(
  undefined
);

export function PromotionSelectionProvider({ children }: { children: React.ReactNode }) {
  const [selectedPromotionId, setSelectedPromotion] = useState<string | null>(null);
  return (
    <PromotionSelectionContext.Provider value={{ selectedPromotionId, setSelectedPromotion }}>
      {children}
    </PromotionSelectionContext.Provider>
  );
}

export function usePromotionSelection() {
  const ctx = useContext(PromotionSelectionContext);
  if (!ctx) {
    throw new Error("usePromotionSelection must be used inside a PromotionSelectionProvider");
  }
  return ctx;
}
